module.exports = __webpack_public_path__ + "img/surety-bond.1495b79e.webp";